export default __webpack_public_path__ + "static/media/ilimo_mobiili_muokkaus.ce77855a.png";